"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRandomInt = getRandomInt;
var MAX_VALUE = 4294967295;
var getRandomNumber = function() {
    var _window_crypto;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions -- needed
    if (((_window_crypto = window.crypto) === null || _window_crypto === void 0 ? void 0 : _window_crypto.getRandomValues) && window.Uint32Array) {
        getRandomNumber = function() {
            var value = window.crypto.getRandomValues(new Uint32Array(1))[0];
            if (typeof value === 'undefined') {
                return Math.random();
            }
            return value / MAX_VALUE;
        };
    } else {
        getRandomNumber = function() {
            return Math.random();
        };
    }
    return getRandomNumber();
};
function getRandomInt(min, max) {
    var ceiledMin = Math.ceil(min);
    var flooredMax = Math.floor(max);
    return Math.floor(getRandomNumber() * (flooredMax - ceiledMin + 1)) + ceiledMin;
} //# sourceMappingURL=getRandomInt.js.map
